import { render, staticRenderFns } from "./team.vue?vue&type=template&id=f85d721a"
import script from "./team.ts?vue&type=script&lang=js&external"
export * from "./team.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports